module.exports = "/images/sg.png?1ae5052bd0ae4b394fb376e88fa7692e";